/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-modialog';
import * as i2 from '@angular/common';
export const ModalModuleNgFactory:i0.NgModuleFactory<i1.ModalModule> = i0.ɵcmf(i1.ModalModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[ModalOverlayNgFactory,CSSBackdropNgFactory,CSSDialogContainerNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,i2.NgLocalization,
          i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i1.Overlay,i1.Overlay,
          [i1.OverlayRenderer,i0.Injector]),i0.ɵmpd(512,i2.CommonModule,i2.CommonModule,
          ([] as any[])),i0.ɵmpd(512,i1.ModalModule,i1.ModalModule,([] as any[]))]);
    });
const styles_ModalOverlay:any[] = ([] as any[]);
export const RenderType_ModalOverlay:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_ModalOverlay,
    data:{}});
function View_ModalOverlay_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_ModalOverlay_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),0,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_ModalOverlay_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_ModalOverlay_3)),i0.ɵdid(2,
      671744,(null as any),0,i2.NgComponentOutlet,[i0.ViewContainerRef],{ngComponentOutlet:[0,
          'ngComponentOutlet'],ngComponentOutletInjector:[1,'ngComponentOutletInjector'],
          ngComponentOutletContent:[2,'ngComponentOutletContent']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.component;
    const currVal_1:any = _v.context.$implicit.injector;
    const currVal_2:any = _v.context.$implicit.projectableNodes;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
export function View_ModalOverlay_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{container:0}),i0.ɵqud(402653184,2,{innerVcr:0}),
      i0.ɵqud(402653184,3,{template:0}),(_l()(),i0.ɵeld(3,0,[[1,0],['container',1]],
          (null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i0.ɵand(16777216,[[2,3],['innerView',2]],(null as any),0,(null as any),
          View_ModalOverlay_1)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵand(0,[[3,2],['template',2]],
          (null as any),0,(null as any),View_ModalOverlay_2))],(null as any),(null as any));
}
export function View_ModalOverlay_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,16777216,(null as any),(null as any),1,'modal-overlay',
      ([] as any[]),(null as any),[['body','keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('body:keydown' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).documentKeypress($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_ModalOverlay_0,RenderType_ModalOverlay)),i0.ɵdid(1,180224,(null as any),
      0,i1.ModalOverlay,[i1.DialogRef,i0.ViewContainerRef,i0.ElementRef,i0.Renderer],
      (null as any),(null as any))],(null as any),(null as any));
}
export const ModalOverlayNgFactory:i0.ComponentFactory<i1.ModalOverlay> = i0.ɵccf('modal-overlay',
    i1.ModalOverlay,View_ModalOverlay_Host_0,{},{},([] as any[]));
const styles_CSSBackdrop:any[] = ([] as any[]);
export const RenderType_CSSBackdrop:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_CSSBackdrop,
    data:{}});
export function View_CSSBackdrop_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_CSSBackdrop_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'css-backdrop',
      ([] as any[]),[[1,'class',0],[1,'style',2]],(null as any),(null as any),View_CSSBackdrop_0,
      RenderType_CSSBackdrop)),i0.ɵdid(1,180224,(null as any),0,i1.CSSBackdrop,[i0.ElementRef,
      i0.Renderer],(null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).cssClass;
    const currVal_1:any = i0.ɵnov(_v,1).styleStr;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const CSSBackdropNgFactory:i0.ComponentFactory<i1.CSSBackdrop> = i0.ɵccf('css-backdrop',
    i1.CSSBackdrop,View_CSSBackdrop_Host_0,{},{},([] as any[]));
const styles_CSSDialogContainer:any[] = ([] as any[]);
export const RenderType_CSSDialogContainer:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CSSDialogContainer,data:{}});
export function View_CSSDialogContainer_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_CSSDialogContainer_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'css-dialog-container',
      [['role','dialog'],['tabindex','-1']],(null as any),(null as any),(null as any),
      View_CSSDialogContainer_0,RenderType_CSSDialogContainer)),i0.ɵdid(1,180224,(null as any),
      0,i1.CSSDialogContainer,[i1.DialogRef,i0.ElementRef,i0.Renderer],(null as any),
      (null as any))],(null as any),(null as any));
}
export const CSSDialogContainerNgFactory:i0.ComponentFactory<i1.CSSDialogContainer> = i0.ɵccf('css-dialog-container',
    i1.CSSDialogContainer,View_CSSDialogContainer_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/~/ngx-modialog/src/ngx-modialog.ng-flat.ngfactory.ts